import React, { cloneElement, useEffect, useState, useContext } from "react";
import styles from "./styles";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Text from "../../../../Diathrive/src/components/elements/Text";
import {
  BUTTON_TYPES,
  COLORS,
} from "../../../../Diathrive/src/utils/Constants";
import { SIDE_PANNEL_ITEMS, SIDE_PANNEL_TEXT } from "../../utils/Constants";
import Popup from "../../../../Diathrive/src/components/elements/Popup";
import Button from "../../../../Diathrive/src/components/elements/Button";
import { getUserProfileData } from "../../../../Diathrive/src/utils/GeneralStorage";
import {
  HTTP_METHODS,
  VIEW_DETAILS,
} from "../../../../Diathrive/src/utils/URLConstants";
import { fetchApi } from "../../../../Diathrive/src/utils/ApiHelper";
import UserAvatar from "../../../../Diathrive/src/components/elements/UserAvatar";
import { tID } from "../../../../Diathrive/src/utils/TestIdHelper";
import {
  LogoGroup,
  LogoutIcon,
} from "../../../../Diathrive/src/utils/SvgIcons";
import CommonStyles from "../../../../Diathrive/src/utils/CommonStyles";
import { RightChevronIcon } from "../../utils/SvgIcons";
import { View } from "react-native";
import { shopContext } from "../../../../Diathrive/src/contexts/ShopContext";
import { removeAllLocalData } from "../../../../Diathrive/src/utils/HelperMethods";

export const SignoutPopup = ({
  open = false,
  setOpen = () => {},
  navigate,
}) => {
  const ShopC = useContext(shopContext);

  return (
    <Popup
      testID={tID("SidePannel-Popup-SignOut")}
      visible={open}
      title={"Sign Out"}
      onRequestClose={() => setOpen(false)}
      description={
        <Text
          testID={tID("SidePannel-Text-SignOutConfirmation")}
          color={COLORS.grey2}
          variation="Body1SemiBold"
        >
          Are you sure you want to sign out from your Diathrive Health account?
        </Text>
      }
      modalViewStyle={styles.modalViewStyle}
    >
      <Button
        testID={tID("SidePannel-Button-Cancel")}
        style={styles.cancel}
        onPress={() => setOpen(false)}
        title={"Cancel"}
      />
      <Button
        testID={tID("SidePannel-Button-SignOut")}
        style={styles.signout}
        title={"Sign Out"}
        onPress={async () => {
          await removeAllLocalData(ShopC);
          navigate("/login");
        }}
        buttonType={BUTTON_TYPES.Filled}
        titleColor={COLORS.white}
      />
    </Popup>
  );
};

export const SidebarElement = ({
  id,
  url,
  Icon,
  ActiveIcon,
  text,
  pathname,
  setOpenManualEntry = () => {},
  setHeaderName = () => {},
}) => (
  <div
    data-testid={tID(`SidePannel-div-Entry${id}`)}
    style={
      url && pathname?.includes(url)
        ? { ...styles.active, ...styles.listItem }
        : { ...styles.listItem }
    }
  >
    <Link
      data-testid={tID(`SidePannel-div-Link${id}`)}
      style={styles.navLink}
      id={id.toString()}
      key={id}
      to={url}
      onClick={() => {
        setOpenManualEntry(false);
        if (text !== SIDE_PANNEL_TEXT.RESOURCES) {
          setHeaderName(text);
        }
      }}
    >
      <div style={styles.spIconText}>
        <View style={styles.spIcon}>
          {cloneElement(url && pathname?.includes(url) ? ActiveIcon : Icon, {
            testID: tID(
              `SidePannel-img-${
                url && pathname?.includes(url) ? "ActiveIcon" : "InactiveIcon"
              }${id}`
            ),
          })}
        </View>
        <Text
          testID={tID(`SidePannel-Text-Title${id}`)}
          variation="Body1SemiBold"
          color={
            url && pathname?.includes(url) ? COLORS.blueMain1 : COLORS.grey2
          }
        >
          {text}
        </Text>
      </div>
    </Link>
  </div>
);

const SidePannel = ({
  setHeaderName,
  setOpenManualEntry = () => {},
  setOpenMyProfile = () => {},
  openMyProfile = false,
}) => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [profileData, setProfileData] = useState();
  const [profileImage, setProfileImage] = useState();

  useEffect(() => {
    if (!openMyProfile) {
      getProfile();
      getUserProfile();
    }
  }, [openMyProfile]);

  const getUserProfile = () => {
    fetchApi(HTTP_METHODS.GET, VIEW_DETAILS)
      .then((res) => res.data)
      .then((response) => {
        const profile = response.data.data;
        setProfileImage(profile.signedImageUrl);
      })
      .catch((error) => {
        // console.log(error);
      });
  };

  const getProfile = async () => {
    const profile = await getUserProfileData();
    setProfileData(profile);
    // console.log("Profile", profile);
  };

  const navigateToSettings = () => {
    setOpenManualEntry(false);
    setOpenMyProfile(true);
    navigate("/settings");
  };

  return (
    <div data-testid={tID("SidePannel-div-Main")} style={styles.mainContainer}>
      <div>
        <div key="logo">
          <LogoGroup width={115} height={32} style={styles.diathrive_logo} />
        </div>
        <hr key="firstDivider" style={styles.divider} />

        {SIDE_PANNEL_ITEMS.map((item, index) => (
          <div key={`allMenuEntries${index}`}>
            {item.map((element) => (
              <SidebarElement
                key={`element-${element.id}`}
                pathname={pathname}
                setHeaderName={setHeaderName}
                setOpenManualEntry={setOpenManualEntry}
                {...element}
              />
            ))}
            <hr key={`Divider${index}`} style={styles.divider} />
          </div>
        ))}

        <div key="Sign-out" style={styles.listItem}>
          <div
            data-testid={tID("SidePannel-div-SignOut")}
            style={styles.spIconText}
            onClick={() => {
              setOpenManualEntry(false);
              setOpen(true);
            }}
          >
            <LogoutIcon
              testID={tID("SidePannel-img-SignoutIcon")}
              width={24}
              height={24}
              tintColor={COLORS.grey2}
            />
            <Text
              testID={tID("SidePannel-Text-SignOut")}
              variation="Body1SemiBold"
              color={COLORS.grey2}
            >
              Sign-out
            </Text>
          </div>
        </div>
        <div key="lastDivider" style={styles.imageProfileDevider}>
          <hr style={styles.divider} />
        </div>
      </div>

      <SignoutPopup open={open} setOpen={setOpen} navigate={navigate} />
      <div key="image-profile">
        <div
          data-testid={tID("SidePannel-div-Profile")}
          style={styles.imageProfile}
          onClick={navigateToSettings}
        >
          <UserAvatar
            name={profileData?.firstName + " " + profileData?.lastName}
            size={32}
            source={profileImage}
            radius={16}
            onPress={navigateToSettings}
          />
          <div style={styles.imageProfileTextContainer}>
            <Text
              testID={tID("SidePannel-Text-Name")}
              variation="Text1SemiBold"
              color={COLORS.black}
            >
              {`${profileData?.firstname} ${profileData?.lastname}`}
            </Text>
            <Text
              testID={tID("SidePannel-Text-Email")}
              variation="Text2SemiBold"
              color={COLORS.grey2}
            >
              {profileData?.email}
            </Text>
          </div>
          <RightChevronIcon style={CommonStyles.mt_10} />
        </div>
      </div>
    </div>
  );
};

export default SidePannel;
